var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { ExploreService } from 'src/app/explore/explore.service';
import { StoryState } from 'src/app/story/state/story.state';
import { StoryService } from 'src/app/story/story.service';
import { ActivatedRoute } from '@angular/router';
var ViewInternalHeaderComponent = /** @class */ (function () {
    // ---------- Lifecycle ----------
    function ViewInternalHeaderComponent(activatedRoute, store, changeDetectorRef, exploreService, storyService) {
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.exploreService = exploreService;
        this.storyService = storyService;
        // ---------- Class Variables ---------- 
        this.ngUnsubscribe = new Subject();
        this.id = '';
        this.type = '';
        this.category = '';
    }
    ViewInternalHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.story$
            .pipe(filter(function (story) { return story != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (story) {
            _this.id = _this.activatedRoute.snapshot.queryParams.id;
            _this.type = _this.storyService.getStoryType(_this.activatedRoute.snapshot.queryParams.id);
            _this.category = _this.exploreService.getStoryCategory(story);
            _this.changeDetectorRef.markForCheck();
        });
    };
    ViewInternalHeaderComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    Object.defineProperty(ViewInternalHeaderComponent.prototype, "bookmarkActions", {
        get: function () {
            var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
            return __spread([
                BookmarkActionsEnum.CopyLink,
                BookmarkActionsEnum.Embed,
                BookmarkActionsEnum.CopyBookmark
            ], organization ? [BookmarkActionsEnum.CopyTeamBookmark] : []);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Select(StoryState.getStory),
        __metadata("design:type", Observable)
    ], ViewInternalHeaderComponent.prototype, "story$", void 0);
    return ViewInternalHeaderComponent;
}());
export { ViewInternalHeaderComponent };
